import React from 'react';

const Loader = () => {
    return (
        <div className="loader-container min-h-screen">
            <div className="loader"></div>
        </div>
    );
};

export default Loader;
